import { retrieveExtPlatAccDataUseCase } from "@frameworks/web/components/Reports/HoldingReports/di/servicelocator";
export const retrieveExtPlatAccDataThunks = (loader) => async (dispatch, getState) => {
    await retrieveExtPlatAccDataUseCase.execute({
        onSuccess: (data) => {
            localStorage.setItem("acc_data", data !== "" && data !== null
                ? data
                : localStorage.getItem("acc_data"));
            loader(false);
        },
        onError: (error) => { },
    }, null);
    return loader;
};
